import React from 'react';
import paginationFirst from '../assets/images/pagination-first.svg';

export default () => {
  return <img src={paginationFirst} alt="First Page" />;
};
